/* repo/cert*/
import { lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { CertCodec, Cert, Data } from "../store/cert/types";
import { withDecoded, flattenData } from "./";

const CERT = "cert";

function mapToModel(data: object): Cert {
  return withDecoded(CertCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(cert: Data): Data {
  return cert;
}

export async function fetch(id: string | null, params?: {}): Promise<Cert> {
  return fetchApi({
    nestedResourcePath: [CERT],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(cert: Data, query?: string): Promise<Cert> {
  const id = cert.id ? `${cert.id}${query}` : cert.id;
  return insertApi({
    nestedResourcePath: [CERT],
    id: id,
    data: { data: mapToChageset(cert) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) && response.data.length > 0 ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: [CERT],
    id: id,
  }).then(() => true);
}
